import alt from '../alt';
import filterAction from './filterAction';
import contractorAction from './contractorAction';
import modalAction from './modalAction';

class condoSetAction {
    constructor() {
        this.generateActions(
            'processing',

            'warningMsg',

            'checkListSuccess',
            'condoSuccess',
            'addCondoSuccess',
            'condo',
            'checkList',
            'addStaff',
            'removeStaff',
            'shouldListShow',
            'shouldListShowCL',
            'shouldListShowCL2',
            'addContractor',
            'addService',
            'removeContractor',
            'editService',
            'removeService',
            'clear',
            'reset',
            'condoRemoveSuccess',
            'isCLUpdate',
        );
    }
    getCondo(mcst) {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/condo/condo/' + mcst, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.condoSuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        /*

        this.condoSuccess({
            _id: "123",
            mcst: 1234,
            condoName: "Condo A",
            noUnit: 30,
            address: "99 Jervios Road",
            postal: 249055,
            geoLocation: { type: "Point", coordinates: [-73.856077, 40.848447] },
            manageBy: [{ staffId: "A0001", userName: "Ho Kok Liang", role: 0, email: "HKL@gmail.com" }, { staffId: "A0002", userName: "Tan Kai Lee", role: 1, email: "TKL@gmail.com" }],
            checkList: ["1234", "1236"],
            contractors: [
                {
                    _id: "A124",
                    contractorName: "E&T Cleaning Services Pte Ltd",
                    contractorEmail: "crankpwr@singnet.com.sg",
                    telephone: 91112222,
                    contract: [
                        {
                            service: "Cleaning", description: "Cleaning", remark: "",
                            contractStartDate: new Date("2016-11-15"), contractEndDate: new Date("2017-11-14"),
                            amount: 2400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28")
                        },
                        {
                            service: "Electric", description: "Electric", remark: "",
                            contractStartDate: new Date("2016-11-15"), contractEndDate: new Date("2017-11-14"),
                            amount: 400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28")
                        }
                    ]
                }
            ]
        });
        this.processing(false);
        */
        return true;
    }
    removeCheckList(id) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("DELETE", '/v1/api/condo/checklist/' + id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        modalAction.modalContent({ title: "Successful", content: "Facility has been deleted" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
    }
    getCheckList() {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/condo/checklist', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.checkListSuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        /*
        this.checkListSuccess([
            { facility: "Common Area", categories: [{ category: "Bin", description: ["Free of smell, cigarette butt, ashes, stickers, stains and dust"] }, { category: "Floor / Skirting", description: ["Tiles are free from grime, stains and mop mark.", "No stagnant water on tiles"] }] },
            { facility: "Lifts", categories: [{ category: "Lift Door", description: ["Close properly and without any hiccups.", "Lift car door has been polished"] }, { category: "Lift Button", description: ["All buttons are present, are working well and lights up when pressed"] }] },
            { facility: "Common Toilets", categories: [{ category: "Door surface / Frame / Closer", description: ["Free of dust and stain"] }, { category: "Light Diffuser", description: ["Check for any blown and/or flickering light bulbs"] }] },
        ]);
        this.processing(false);
        */
        return true;
    }

    addCondo(condo) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/condo', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {

                        filterAction.addCondo(result);
                        contractorAction.addWholeCondo(result);
                        this.addCondoSuccess();
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Condo has been added" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ condo: condo }));
        }
        return true;
    }
    removeContractorFrDB(contractorId, mcst) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/condo/contractor/' + contractorId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Contractor has been erased from this estate" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ mcst: mcst }));
        }
        return true;
    }
    updateCondo(condo, prevMCST) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/condo/' + prevMCST, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        contractorAction.updateWholeCondo(result);
                        filterAction.updateCondo({ newMCST: condo.mcst, prevMCST: prevMCST, condoName: condo.condoName });
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Condo has been updated" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ condo: condo }));
        }
        return true;
    }
    removeCondo(condo) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("DELETE", '/v1/api/condo/' + condo.mcst, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.condoRemoveSuccess();
                        filterAction.removeCondo(condo.mcst);
                        contractorAction.removeWholeCondo(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Condo has been deleted" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    updateCheckList(checkList) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/condo/checklist', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.checkListSuccess(result);
                        this.isCLUpdate(true);

                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ checkList: checkList }));
        }
        return true;
    }
    exportCheckList() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/checkList', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {

                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    exportCondo(mcst) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/condo/' + mcst, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "EstateDetail_" + mcst + ".xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }

}
export default alt.createActions(condoSetAction);


// WEBPACK FOOTER //
// ./app/actions/condoSetAction.js